export default __webpack_public_path__ + "static/media/iconmonstr-github-1.04be58c1.svg";